import pLimit from "p-limit";

const DEFAULT_CONCURRENCY = 5;

const limit = pLimit(DEFAULT_CONCURRENCY);

/**
 * Maps over items with a concurrency limit, returning results in the same order as the input.
 */
export const mapWithLimit = <T, R>(
  items: T[],
  fn: (item: T, index: number) => Promise<R>
): Promise<R[]> => {
  return Promise.all(items.map((item, index) => limit(() => fn(item, index))));
};
